import React, { useState, useCallback, useEffect, useRef } from 'react';
import { Grow, Position, Width } from './types';

import * as S from './styles';

type Props = {
  children: React.ReactNode;
  toggleElement: React.ReactElement;
  toggleElementStyles?: {};
  position?: Position;
  grow?: Grow;
  width?: Width;
};

const Menu = ({
  children,
  toggleElement,
  toggleElementStyles,
  position = 'bottom',
  grow = 'right',
  width = 'auto',
}: Props) => {
  const [visible, setVisibilityState] = useState<boolean>(false);
  const menuRef = useRef<HTMLDivElement>(null);

  const toggleMenu = useCallback(() => {
    setVisibilityState(!visible);
  }, [visible]);

  const handleClickOutside = (e: Event) => {
    if (menuRef.current && !menuRef.current.contains(e.target as Node)) {
      setVisibilityState(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  if (!toggleElement) return null;

  return (
    <S.Menu ref={menuRef}>
      <toggleElement.type
        style={toggleElementStyles}
        onClick={toggleMenu}
        {...toggleElement.props}
        data-test="MenuToggleElement"
      />

      {visible && (
        <S.MenuDropdown width={width} position={position} grow={grow}>
          {children}
        </S.MenuDropdown>
      )}
    </S.Menu>
  );
};

export default Menu;
